app.controller("LoginAlertsController", ["$scope", "$http", "AuthService", "ConfirmModal",
    function ($scope, $http, AuthService, ConfirmModal) {

        $scope.alerts = [];

        $scope.getAlerts = function () {
            AuthService.getAlerts().then(function (data) {
                $scope.alerts = data;
            })
        }

        $scope.getAlerts();

        $scope.agree = function (_id) {
            AuthService.alertAction({ _id, truthed: true }).then(function (data) {
                $scope.getAlerts();
            })
        };


        $scope.disagree = function (_id) {
            ConfirmModal.show({
                title: "ნამდვილად გსურთ მოწყობილობის დაბლოკვა?",
                message: "დაბლოკვის შემთხვევაში აქტიური სესია წაიშლება და ვეღარ შეძლებს სისტემაში შესვლას"
            }).result.then(function () {
                AuthService.alertAction({ _id, truthed: false }).then(function (data) {
                    $scope.getAlerts();
                })
            });

        };

    }
]);